import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';

NotFound[$.FILENAME] = 'src/pages/NotFound.svelte';

import * as $ from 'svelte/internal/client';
import EmptyState from "../components/EmptyState.svelte";

export default function NotFound($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, false, NotFound);

	var $$exports = { ...$.legacy_api() };

	$.add_svelte_meta(
		() => EmptyState($$anchor, {
			icon: '🧭',
			title: 'We can\'t find that page',
			message: 'The link may be old, or there\'s a typo in the address.',
			action: { href: "/", label: "Back to browsing" }
		}),
		'component',
		NotFound,
		5,
		0,
		{ componentTag: 'EmptyState' }
	);

	return $.pop($$exports);
}